<template>
    <div style="display: block;">
        <router-link v-for="(userInfo, index) in userInfos" :key="index"
            :to="{ name: 'userArt', query: { user_id: userInfo.user_id } }" style="text-decoration: none;" v-sliden_in>
            <div class="userInfo-Box">
                <div class="userInfo-avatar">
                    <img :src="userInfo.avatar" alt="">
                </div>
                <div class="userInfo-inf">
                    <div class="userInfo-base">
                        <p class="nick-name">
                            {{ userInfo.nick_name }}
                        </p>
                        <p class="user-id">
                            id: {{ userInfo.user_id }}
                        </p>
                    </div>
                    <div class="userInfo-desc">
                        {{ userInfo.desc }}
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>


export default {
    name: 'SearchAuthor',
    data() {
        return {
            // animationMap: new WeakMap(),
            // ob: new IntersectionObserver((entries) => {
            //     for (const entry of entries) {
            //         if (entry.isIntersecting) {
            //             const animation = this.animationMap.get(entry.target);
            //             animation.play();
            //             ob.unobserve(entry.target);
            //         }
            //     }
            // }),
            keyword: this.$route.query.keyword,
            userInfos: [{
                user_id: '',
                nick_name: '',
                avatar: "",
                desc: '',
            }]
        }
    },
    components: {
    },
    methods: {
        loadData() {
            var url = "https://www.vilipix.com/api/v1/search/user?type=author&keyword=" + this.keyword + "&limit=30&offset=0";
            this.$axios.get(url).then(res => {
                this.userInfos = this.user_id = res.data.data.rows
            }).catch(error => {
                console.log(error);
            })
        }
    },
    // beforeCreate() {
    //     this.animationMap = new WeakMap();
    //     this.ob = new IntersectionObserver((entries) => {
    //         for (const entry of entries) {
    //             if (entry.isIntersecting) {
    //                 const animation = this.animationMap.get(entry.target);
    //                 animation.play();
    //                 this.ob.unobserve(entry.target);
    //             }
    //         }
    //     })
    // },
    created() {
        this.loadData();
        // console.log(this.ob)


    },
    watch: {
        '$route'(to, from) {
            this.keyword = this.$route.query.keyword;
            this.loadData();
        }
    },
    
}

</script>

<style scoped>
.userInfo-Box {
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    padding: 10px 10px;
    /* background-color: antiquewhite; */
    border-bottom: solid 1px #757470;
}

.userInfo-avatar {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
}

.userInfo-avatar>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.userInfo-inf {
    width: 80%;
    margin-left: 20px;
    text-align: left;
}

.userInfo-base {
    display: block;
}

.nick-name {
    font-size: 1.6rem;
    margin: 0;
    color: black;
}

.user-id {
    font-size: .8rem;
    color: #757470;
    margin: 0;
    margin-bottom: 10px;
}

.userInfo-desc {
    font-size: 1rem;
    color: #757470;
}
</style>